import React from 'react';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { List } from "@material-ui/core";
import StrategyName from "../../client/StrategyName";
import {getCurrentPolicyYear, nextAnniversaryDate} from "../../../pages/clientServicing/ClientServiceDashbaord";
import moment from "moment/moment";
import { usePolicyContext } from "./PolicyContext";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import numeral from "numeral";

const styles = (theme: Theme) =>
        createStyles({
            root: {
                margin: 0,
                padding: theme.spacing(2),
            },
            closeButton: {
                position: 'absolute',
                right: theme.spacing(1),
                top: 18,
                color: theme.palette.grey[500],
            },
        });

export interface DialogTitleProps extends WithStyles<typeof styles> {
    id: string;
    children: React.ReactNode;
    onClose: () => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
    const { children, classes, onClose, ...other } = props;
    return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                ) : null}
            </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

export default function PersonalChecksPaymentModal(props: any) {
    const { onClose, caseDetail, strategyName } = props;
    const issueDate = caseDetail && caseDetail.tranche && caseDetail.tranche.issueDate;
    let anniversaryDate = nextAnniversaryDate(issueDate);
    let currentAnniversaryYear = getCurrentPolicyYear(anniversaryDate);
    const profile = useSelector((state: RootState) => state.profile);
    const {policy}: any = usePolicyContext();
    const clientPolicy =  profile.client && profile.client.clientPolicies && profile.client.clientPolicies.length > 0 && profile.client.clientPolicies[0]
    const paymentFrequency: string = clientPolicy && clientPolicy.paymentFrequency || "annual";
    const timeTable = paymentFrequency === "annual" ? policy && policy.paymentTimetableAnnual : policy && policy.paymentTimetableMonthly;
    const nextPaymentDetails = timeTable && timeTable.nextPayment;
    const recurringPaymentDate = nextPaymentDetails && nextPaymentDetails.date ? moment(nextPaymentDetails.date).format("MM/DD/YYYY") : "";
    const recurringPaymentAmount = nextPaymentDetails && nextPaymentDetails.amount ?  numeral(nextPaymentDetails.amount[0].amount + nextPaymentDetails.amount[1].amount).format("$0,0") : <span style={{color: "#3cda93"}}>No payment due</span>;

    const { trustDetails, tranche } = caseDetail;
    const handleClose = () => {
        onClose();
    };

    return (
                <Dialog fullWidth={true} maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={true}>
                    <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                        Personal Check Payment Details
                    </DialogTitle>
                    <DialogContent dividers>
                        <Typography variant="body1">
                            The policy holder must also be on the account the check is written from. We can only process
                            personal checks. No business checks will be accepted. Once payment is received, your
                            contribution totals and payment history will be updated.
                        </Typography>
                        <List className="textLeft">
                            <li className="floatLeft w100">
                                <Typography variant="body1" className="floatLeft">{currentAnniversaryYear} Contribution Balance Owed:</Typography>
                                <Typography variant="body1" className="floatRight">
                                    {recurringPaymentAmount}
                                </Typography>
                            </li>
                            <li className="floatLeft w100">
                                <Typography variant="body1" className="floatLeft">Check must be in by:</Typography>
                                <Typography variant="body1" className="floatRight">{recurringPaymentDate}</Typography>
                            </li>
                            <li className="floatLeft w100">
                                <Typography variant="body1" className="floatLeft">Make Check payable to:</Typography>
                                <Typography variant="body1" className="floatRight"><StrategyName strategyName={strategyName}/>&nbsp;{trustDetails && trustDetails.trustName || ""}&nbsp;{tranche && tranche.trancheNumber}</Typography>
                            </li>
                            <li className="floatLeft w100">
                                <Typography variant="body1" className="floatLeft"> Mail or overnight to:</Typography>
                                <address className="floatRight">
                                    Kai-Zen Plan Servicing LCC.
                                    5830 GRANITE PARKWAY, Suite 700
                                    Plano, Tx 75024
                                </address>
                            </li>
                        </List>
                    </DialogContent>
                    <DialogActions>
                        <Button  className="mt15 mb15" variant="contained" onClick={handleClose} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
    );
}